<template lang='pug'>
  v-combobox(
    ref='phoneNumbers'
    :value='value'
    @input='update'
    :label='label'
    chips
    deletable-chips
    persistent-hint
    hint='Enter phone numbers'
    hide-no-data
    multiple
    append-icon=''
    small-chips)
</template>

<script>
export default {
  name: 'SmsPhoneNumbers',
  props: {
    label: {
      default() {
        return 'Phone Numbers';
      }
    },
    value: {
      default() {
        return [];
      }
    }
  },
  methods: {
    update(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style scoped>
</style>
